import Axios from "axios";
import fileDownload from "js-file-download";
import { sessionService } from "redux-react-session";
import { Api, Notification } from "../services";
import { logout, updateOrgDetails } from "./login";
import { getStorageData, getStorageDetails } from "./digitalLibrary";
import moment from 'moment'

export const UPDATE_INSTITUTE_DETAILS = "UPDATE_INSTITUTE_DETAILS";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const UPDATE_SUPPORT_NUMBERS = "UPDATE_SUPPORT_NUMBERS";
export const SET_GS_TAB = "SET_GS_TAB";
export const SET_KYC_TAB = "SET_KYC_TAB";
export const SET_OTHERS_TAB = "SET_OTHERS_TAB";
export const STORE_KYC_DETAILS = "STORE_KYC_DETAILS";
export const SET_SUBSCRIPTIONS_TAB = "SET_SUBSCRIPTIONS_TAB";
export const UPDATE_STORAGE_SUBS_DETAILS = "UPDATE_STORAGE_SUBS_DETAILS";
export const UPDATE_BROADCAST_SUBS_DETAILS = "UPDATE_BROADCAST_SUBS_DETAILS";
export const UPDATE_SEARCHED_USERS_LIST = "UPDATE_SEARCHED_USERS_LIST";
export const UPDATE_ATTENDANCE_SETTINGS = "UPDATE_ATTENDANCE_SETTINGS";
export const UPDATE_AULAS_SUBS_DETAILS = "UPDATE_AULAS_SUBS_DETAILS";
export const UPDATE_STUDENT_CLASS_DETAILS = "UPDATE_STUDENT_CLASS_DETAILS";
export const UPDATE_STUDENT_FEE_DETAILS = "UPDATE_STUDENT_FEE_DETAILS";
export const UPDATE_USER_ATTENDANCE_OVERVIEW = "UPDATE_USER_ATTENDANCE_OVERVIEW";
export const UPDATE_USER_ATTENDANCE_REQUESTS = "UPDATE_USER_ATTENDANCE_REQUESTS";
export const UPDATE_HOLIDAYS = "UPDATE_HOLIDAYS";
export const UPDATE_LEAVES_DATA_V3 = "UPDATE_LEAVES_DATA_V3";
export const ALLOWED_LEAVES_TYPES = "ALLOWED_LEAVES_TYPES";
export const STORE_CFRT = 'STORE_CFRT'
export const PAYMENT_DETAILS = 'PAYMENT_DETAILS'
export const UPDATE_USER_ACTIVITY = 'UPDATE_USER_ACTIVITY'
export const APPEND_USER_ACTIVITY = 'APPEND_USER_ACTIVITY'
export const SET_TRANSACTION_DATA = 'SET_TRANSACTION_DATA'
export const STORE_MARKETPLACE_SETTING = 'STORE_MARKETPLACE_SETTING'

export const storeMarketPlaceSetting = res => ({
    type: STORE_MARKETPLACE_SETTING,
    res
})

// export const deleteRequest = (params, callback, successCallback, pagecallback) => {
//     return (dispatch, getState) => {

//         const url = ``;
//         return  Api.delete(url).params(params).send((response, error) => {
//             if (response && response.show.type === "success") {
//                 if (response && response.show.type === "success") {
//                     successCallback()
//                     pagecallback(true)
//                     if(params.requestType === "Leave"){
//                         dispatch(getLeavesData(params,() =>  pagecallback(false)))
//                     }else{
//                         dispatch(getAttendanceRequests(params,() =>  pagecallback(false)))
//                     }

//                 }
//             }
//             callback(response);
//         });
//   };
// }

export const calculateLeaveDays = (params, callback) => {
    return (dispatch, getState) => {

        const url = `/attendancev2/calculate-dates`;
        return Api.get(url).params(params).send((response, error) => {
            if (response) {
                callback(response);
            }
        });
    };
}

export const updatePermanentlLocation = (params, callback, successCallback, pagecallback) => {
    return (dispatch, getState) => {

        const url = `/attendancev2/profile/geo-fence/${params.userId}/edit-permanent-allocation`;
        return Api.post(url).params(params).send((response, error) => {
            if (response && response.show.type === "success") {
                successCallback();
                pagecallback(true)
                dispatch(getHolidays(params, () => pagecallback(false)))
            }
            callback();
        });
    };
}

export const requestLeaveOrAttendance = (params, callback, successCallback, pagecallback) => {
    const targetDate = params?.startDate ? moment(params.startDate) : moment();
    const currentYear = targetDate.isValid() ? targetDate.year() : moment().year();
    const currentMonth = targetDate.isValid() ? (targetDate.month() + 1) : (moment().month() + 1);
    return (dispatch, getState) => {
        const url = params.commonId ? `/attendancev2/edit-request` : `/attendancev2/request`;
        console.log("consoling_in_V3", params);
        const params1 = {
            userId: params.userId,
            month: currentMonth,
            year: currentYear
        }
        return Api.post(url).params(params).send((response, error) => {
            if (response && response.show.type === "success") {
                successCallback()
                pagecallback(true)
                if (params.requestType === "Leave") {
                    dispatch(getLeavesData(params1, () => pagecallback(false)))
                } else {
                    dispatch(getAttendanceRequests(params1, () => pagecallback(false)))
                }

            }
            callback();
        });
    };
}



export const leaveOrAttendanceRequestActions = (params, callback, pagecallback, successCallback) => {
    return (dispatch, getState) => {
        const url = `/attendancev2/request-action-v2`;
        const targetUserId = params?.userId || getState().userManagementV2?.userRowDetails?.id || getState().userManagementV2?.specificUserId || getState().session?.user?.id;

        return Api.post(url).params(params).send((response, error) => {
            if (response) {
                if (typeof successCallback === 'function') {
                    successCallback(response);
                }
                if (params?.requestType === 'Leave') {
                    if (targetUserId) {
                        dispatch(getLeavesData({ userId: targetUserId, page: 1, limit: 10 }, () => {
                            if (typeof pagecallback === 'function') pagecallback(false);
                        }));
                    } else {
                        if (typeof pagecallback === 'function') pagecallback(false);
                    }
                } else if (window.location.pathname !== '/attendance/requests' && window.location.pathname !== '/attendance/admin') {
                    if (targetUserId) {
                        dispatch(getAttendanceRequests({ userId: targetUserId, page: 1, limit: 10 }, () => {
                            if (typeof pagecallback === 'function') pagecallback(false);
                        }));
                    } else {
                        if (typeof pagecallback === 'function') pagecallback(false);
                    }
                } else {
                    if (typeof pagecallback === 'function') pagecallback(false);
                }
            } else {
                if (typeof pagecallback === 'function') pagecallback(false);
            }
            if (typeof callback === 'function') callback(response, error);
        });
    };
}

const updateLeavesData = (data) => ({
    type: UPDATE_LEAVES_DATA_V3,
    data
})

// export const getLeavesData = (params, callback) => {
//     console.log("consolingPrams",params);
//     return (dispatch, getState) => {
//         const url = `/attendance-v3/profile/${params.userId}/leave`;
//         return Api.get(url).params(params).send((response, error) => {
//             if (response) {
//                 dispatch(updateLeavesData(response))
//             }
//             callback();
//         });
//     };
// }
export const getLeavesData = (params, callback) => {
    console.log("consolingPrams", params);
    return (dispatch, getState) => {
        if (!params?.userId) {
            if (callback) {
                callback();
            }
            return;
        }
        const url = `/attendancev2/profile/${params.userId}/leave`;
        const { userId, ...restParams } = params || {};
        const queryParams = {};
        Object.keys(restParams).forEach((key) => {
            if (restParams[key] !== undefined && restParams[key] !== null && restParams[key] !== '') {
                if (key === 'month') {
                    const m = restParams[key];
                    if (!isNaN(Number(m))) {
                        queryParams[key] = Number(m);
                    } else {
                        const parsed = moment(m, ['MMM', 'MMMM']).month() + 1;
                        queryParams[key] = !isNaN(parsed) && parsed >= 1 && parsed <= 12 ? parsed : m;
                    }
                } else if (key === 'year') {
                    queryParams[key] = Number(restParams[key]) || restParams[key];
                } else {
                    queryParams[key] = restParams[key];
                }
            }
        });
        const request = Object.keys(queryParams).length > 0
            ? Api.get(url).params(queryParams)
            : Api.get(url);

        return request.send((response, error) => {
            if (response) {
                dispatch(updateLeavesData(response))
            }
            if (callback) {
                callback();
            }
        });
    };
}
const updateLeavesTypes = (data) => ({
    type: ALLOWED_LEAVES_TYPES,
    data
})

export const getLeavesTypes = (callback) => {
    return (dispatch, getState) => {
        const url = `/attendancev2/get-all-leaves`;
        return Api.get(url).send((response, error) => {
            if (callback) {
                callback();
            }
            if (response) {
                console.log("here111", response);
                dispatch(updateLeavesTypes(response))

            }
            // callback();
        });
    };
}

export const saveHolidays = (params, callback, pagecallback) => {
    return (dispatch, getState) => {
        const url = `/attendancev2/profile/${params.userId}/holiday/save-list`;
        return Api.post(url).params(params).send((response, error) => {
            if (response) {
                if (pagecallback) pagecallback(true);
                delete params.dates
                dispatch(getHolidays(params, pagecallback))
            }
            if (callback) callback(response, error);
        });
    };
}

export const updateHolidays = (data) => ({
    type: UPDATE_HOLIDAYS,
    data
})

export const getHolidays = (params, callback) => {
    return (dispatch, getState) => {
        const url = `/attendancev2/profile/${params.userId}/holiday`;
        return Api.get(url).params(params).send((response, error) => {
            console.log('holi', response);
            if (response) {
                dispatch(updateHolidays(response))
            }
            if (callback) callback(response, error);
        });
    };
}


const updateUserAttendanceRequests = (data) => ({
    type: UPDATE_USER_ATTENDANCE_REQUESTS,
    data
})

export const getAttendanceRequests = (params, callback) => {
    return (dispatch, getState) => {
        const url = `/attendancev2/profile/${params.userId}/attendance-requests`;
        return Api.get(url).params(params).send((response, error) => {
            if (response) {
                dispatch(updateUserAttendanceRequests(response))
            }
            callback();
        });
    };

}



const updateUserAttendanceOverview = (data) => ({
    type: UPDATE_USER_ATTENDANCE_OVERVIEW,
    data
})

export const getAttendanceOverview = (params, callback) => {
    return (dispatch, getState) => {
        console.log("paramsparams", params);
        const url = `/attendancev2/profile/${params?.userId}/attendance-overview`;
        return Api.get(url).params(params).send((response, error) => {
            if (response) {
                dispatch(updateUserAttendanceOverview(response))
            }
            if (callback) {
                callback(response, error);
            }
        });
    };
}


const updateStudentFeeDetails = (data) => ({
    type: UPDATE_STUDENT_FEE_DETAILS,
    data
})

export const getFeeDetails = (selectedUserId, callback, fromWhere) => {
    return (dispatch, getState) => {
        const userId = getState().session.user.id;
        const url = `/user/get-student-fee-details/${fromWhere == 'userManagementProfile' ? selectedUserId : userId}`;
        return Api.get(url).send((response, error) => {
            if (response) {
                console.log("feeDetails", response);
                dispatch(updateStudentFeeDetails(response))
            }
            callback();
        });
    };
}


export const setSubscriptionSelectedTab = (tab) => ({
    type: SET_SUBSCRIPTIONS_TAB,
    tab
})

export const setKycSelectedTab = (tab) => ({
    type: SET_KYC_TAB,
    tab
})

export const setOthersSelectedTab = (tab) => ({
    type: SET_OTHERS_TAB,
    tab
})

export const setGsSelectedTab = (tab) => ({
    type: SET_GS_TAB,
    tab
})

const updateInstituteDetails = (data) => ({
    type: UPDATE_INSTITUTE_DETAILS,
    data
})

const updateUserDetails = (data) => ({
    type: UPDATE_USER_DETAILS,
    data
})

const updateSupportNumber = (data) => ({
    type: UPDATE_SUPPORT_NUMBERS,
    data
})

const updateAttendanceSettings = data => ({
    type: UPDATE_ATTENDANCE_SETTINGS,
    data
})

const updateStudentClassDetails = data => ({
    type: UPDATE_STUDENT_CLASS_DETAILS,
    data
})

export const getUserProfileDetails = (callback) => {
    const url = `/user/account-details`;
    return (dispatch, getState) => {
        const userPrivilege = getState().session.user.privilage;
        const userToken = getState().session.user.accessToken;
        const userRole = getState().session.user.role;

        return Api.get(url).send((response, error) => {
            if (response) {
                if (userPrivilege?.length) {
                    dispatch(updateInstituteDetails(response.instituteInfo))
                    dispatch(updateSupportNumber(response.supportPhones))
                }
                if (userRole?.includes("Student")) {
                    dispatch(updateStudentClassDetails(response.studentCourseDetails))
                }
                dispatch(updateUserDetails(response.profile))
                dispatch(updateAttendanceSettings(response.attendanceReminderSettings))
                if (response?.user) {
                    dispatch(updateOrgDetails({
                        title: response?.user?.org?.name,
                        logo: response?.user?.org?.logo,
                        website: response?.user?.org?.website,
                        instituteId: response?.user?.org?.instituteId
                    }));
                    response.user.accessToken = userToken;
                    sessionService.saveSession({ token: userToken }).then(() => {
                        sessionService.saveUser(response.user)
                    })
                }
            }
            if (callback) {
                callback();
            }
        });
    };
}


export const saveProfileDetails = (params, stopGetAccountDetails = false, callback, buttonCallback) => {
    const url = `/user/v2/update-profile`;
    console.log({ params });
    return (dispatch, getState) => {
        return Api.uploadAndPost(url, params, (percent, response) => {
            if (response) {
                if (!stopGetAccountDetails) dispatch(getUserProfileDetails())
                callback();
            }
            console.log({ percent });
            if (percent === 100) {
                buttonCallback();
            }
        });
    };

}

export const saveInstituteDetails = (params, callback, buttonCallback) => {
    const url = `/user/v2/institute-info`;
    return (dispatch, getState) => {
        return Api.uploadAndPost(url, params, (percent, response) => {
            if (response) {
                dispatch(getUserProfileDetails())
                callback();
            }
            console.log({ percent });
            if (percent === 100) {
                buttonCallback();
            }
        });
    };

}


export const saveSupportDetails = (params, callback, buttonCallback) => {
    const url = `/user/support-phones`;
    return (dispatch, getState) => {
        return Api.post(url).params(params).send((response, error) => {
            if (response) {
                dispatch(getUserProfileDetails(callback))
                callback();
            }
            buttonCallback();
        });
    };

}

const storeKycDetails = (data) => ({
    type: STORE_KYC_DETAILS,
    data
})

export const getKycDetails = (callback) => {
    const url = `/fee/kyc`;
    return (dispatch) => {
        return Api.get(url).send((response, error) => {
            if (response) {
                dispatch(storeKycDetails(response))
            }
            callback()
        }
        )
    }
}

export const deleteLogo = (callback, successCallback) => {
    const url = `/user/remove-org-logo`;
    return (dispatch) => {
        return Api.patch(url).send((response, error) => {
            if (response) {
                dispatch(getUserProfileDetails(callback))
                successCallback()
            }
            callback()
        }
        )
    }
}

export const deleteProfilePic = (callback, stopGetAccountDetails = false, successCallback) => {
    return (dispatch, getState) => {

        let userId = null;
        if (window.location.pathname === '/user-management/profile' || window.location.pathname === '/user-management-v2/profile') {
            userId = getState().userManagementV2.userRowDetails?.id;
        } else {
            userId = getState().session?.user?.id;
        }

        const url = `/user/remove-image/${userId}`;
        return Api.patch(url).send((response, error) => {
            if (response) {
                if (!stopGetAccountDetails) dispatch(getUserProfileDetails(callback))
                successCallback()
            }
            callback()
        }
        )
    }
}


export const updateFeeSettings = (params, callback) => {
    const url = `/feev2/updateSettings`;
    return (dispatch, getState) => {
        return Api.post(url).params(params).send((response, error) => {
            if (response) {
                dispatch(getUserProfileDetails())
            }
            callback();
        }
        )
    }
}

export const updateUserSettings = (params, callback) => {
    const url = `/user/addUserSettings`;
    return (dispatch, getState) => {
        return Api.post(url).params(params).send((response, error) => {
            if (response) {
                dispatch(getUserProfileDetails(callback))
            }
        }
        )
    }
}

export const updateAttendanceReminderSettings = (params, callback, successcallback) => {
    const url = `/attendancev2/attendance-reminder-settings`;
    return (dispatch, getState) => {
        return Api.post(url).params(params).send((response, error) => {
            if (response) {
                dispatch(getUserProfileDetails(callback))
                if (response?.show?.type != 'error') {
                    successcallback()
                }
            }
        }
        )
    }
}

export const getStorageSubscriptionDetails = (callback, filter) => {
    const url = `/admin-library/billing-history`;
    return (dispatch, getState) => {
        return Api.get(url).params(filter).send((response, error) => {
            if (response) {

                dispatch(updateStorageSubscriptionDetails(response))
                dispatch(getStorageDetails());
            }
            callback()
        }
        )
    }
}

const updateStorageSubscriptionDetails = (data) => ({
    type: UPDATE_STORAGE_SUBS_DETAILS,
    data
})


export const searchUsers = (search, callback) => {
    const url = `/user/autocomplete`;
    return (dispatch, getState) => {
        const params = {
            name: search,
            roles: ["Teacher", "Data Operator", "Operation"]
        }
        return Api.get(url).params(params).send((response, error) => {
            if (response) {
                dispatch(updateUsersList(response))
            }
            callback()
        }
        )
    }
}

const updateUsersList = (data) => ({
    type: UPDATE_SEARCHED_USERS_LIST,
    data
})

export const transferSuperAdmin = (params, callback = null, successCallback = null, history) => {
    const url = `/user/transfer-ownership`;
    return (dispatch, getState) => {
        return Api.post(url).params(params).send((response, error) => {
            if (callback) {
                callback()
            }
            if (response) {
                if (successCallback) {
                    successCallback();
                }
                dispatch(logout(history, "Ownership changed"))
            }
            callback()
        }
        )
    }
}

export const getBroadcastSubscriptionDetails = (callback, filter) => {
    const url = `/schedule-new/subscription/billing-history`;
    return (dispatch, getState) => {
        return Api.get(url).params(filter).send((response, error) => {
            if (response) {
                dispatch(updateBroadcastSubscriptionDetails(response))
            }
            callback()
        }
        )
    }
}


const updateBroadcastSubscriptionDetails = (data) => ({
    type: UPDATE_BROADCAST_SUBS_DETAILS,
    data
})


export const getAulasSubscriptionDetails = (callback, filter) => {
    const url = `/organisation/billing-history`;
    return (dispatch, getState) => {
        return Api.get(url).params(filter).send((response, error) => {
            if (response) {
                dispatch(updateAulasSubscriptionDetails(response))
            }
            callback()
        }
        )
    }
}

export const downloadInvoices = (params, callback = null, successCallback = null) => {
    const url = `/invoice/download-all`;
    return (dispatch, getState) => {
        return Api.get(url).params(params).send((response) => {
            callback();
            if (response !== undefined) {
                Axios.get(response.url, {
                    responseType: "blob",
                }).then((res) => {
                    if (successCallback) {
                        successCallback(response?.key)
                    }
                    fileDownload(res?.data, response?.name);
                });
            }
        })
    }
}


export const deleteZipFile = (val, callBack = null) => {
    return (dispatch, getState) => {
        const url = `/invoice/delete-zip`;
        return (
            Api.delete(url).params({ key: val }).send((response) => {
                if (callBack) {
                    callBack();
                }
            })
        );
    };
};



const updateAulasSubscriptionDetails = (data) => ({
    type: UPDATE_AULAS_SUBS_DETAILS,
    data
});

export const paymentDetails = (res) => ({
    type: PAYMENT_DETAILS,
    res
})

export const editLeaveInProfile = (params, callback = null, successCallBack = null, pagecallback) => {

    return (dispatch, getState) => {
        const { specificUserId } = getState().userManagement;
        const { user } = getState().session;

        return Api.patch("/attendancev2/update-leaves-for-user").params(params).send((response) => {
            if (callback) callback();
            if (response && response.show.type === "success") {
                successCallBack();
                pagecallback(true)
                dispatch(getLeavesData({ userId: params?.userId }, pagecallback))
            }
        })

    }
}

export const deleteHistory = (params, callback, successCallback, fromWhere) => {
    return (dispatch, getState) => {

        const url = `/attendancev2/trash-request`;

        let userId = null;
        if (window.location.pathname === '/user-management/profile' || window.location.pathname === '/user-management-v2/profile') {
            userId = getState().userManagementV2?.userRowDetails?.id;
        } else {
            userId = getState().session?.user?.id;
        }

        return Api.delete(url).params(params).send((response, error) => {
            if (response && response.show.type === "success") {
                successCallback();
                {
                    fromWhere === 'LeaveSummary' ?
                        dispatch(getLeavesData({ userId: userId }, () => { })) :
                        dispatch(getAttendanceRequests({ userId: userId }, () => { }))
                }
            }
            callback();
        });
    };
};

export const downloadAttendanceBySchedule = (params) => {
    return (dispatch, getState) => {

        let userId = null;
        if (window.location.pathname === '/user-management/profile' || window.location.pathname === '/user-management-v2/profile') {
            userId = getState().userManagementV2.userRowDetails?.id;
        } else {
            userId = getState().session?.user?.id;
        }
        console.log({ userId })

        return Api.post(`/attendancev2/download-attendance-by-occurance/${userId}`).params(params).send((response) => {
            if (response !== undefined) {
                let fileName = response.file.split('/')[response.file.split('/').length - 1];
                Axios.get(response.file, {
                    responseType: "blob",
                }).then((res) => {
                    fileDownload(res.data, fileName);
                });
            }
        });
    };
};

export const getCfrt = (params, callback) => {
    const url = `/feev2/create-order`;
    return (dispatch, getState) => {
        return Api.post(url).params(params).send((response, error) => {
            if (response) {
                console.log({ response })
                // dispatch(storeCashfreeRT(response));
                callback(response?.body);
            }
        }
        )
    }
};

export const postPaymentDetails = (orderId, id, userId) => {
    const url = `/fee/getOrderDetails?orderId=${orderId}&id=${id}&userId=${userId}`;
    return (dispatch, getState) => {
        return Api.get(url).send((response, error) => {
            if (response) {
                dispatch(paymentDetails(response));
                console.log({ response })
            };
        }
        )
    };
};


export const getUserActivity = (params, firstTimeLoading, callback = null, loader = null) => {
    return (dispatch, getState) => {
        return Api.get('/notification/user-activity').params(params || {}).send((response, error) => {
            if (response && !error) {
                if (firstTimeLoading && typeof updateUserActivity === 'function') {
                    try { dispatch(updateUserActivity(response)); } catch (e) { }
                } else if (typeof appendUserActivity === 'function') {
                    try { dispatch(appendUserActivity(response)); } catch (e) { }
                }
            }
            if (typeof callback === 'function') {
                callback(response, error);
            }
            if (typeof loader === 'function') {
                loader();
            }
        });
    };
};

const setTransactionData = (res) => ({
    type: SET_TRANSACTION_DATA,
    res
})

export const getTransactionData = (startDate, endDate, week, isYear, callBack, successCallBack) => {

    const url = `/feev2`;
    console.log("AA-startDate", startDate, endDate, week, isYear);
    return (dispatch, getState) => {
        const { userRowDetails } = getState().userManagementV2;
        let params
        if (week == 'week') {
            params = {
                userId: userRowDetails.id,
                type: week,
                startDate: startDate,
                endDate: endDate,
            }
        } else {
            params = {
                userId: userRowDetails.id,
                type: week,
                year: isYear,

            }
        }

        Api.get(url).params(params).send((response, error) => {
            dispatch(setTransactionData(response))
            if (callBack) {
                callBack()
            }
            console.log('response', response);

            if (response) {
                if (successCallBack) {
                    successCallBack()
                }
            }
        })

    }
};

export const updateUserActivity = (data) => ({
    type: UPDATE_USER_ACTIVITY,
    data
})

export const appendUserActivity = (data) => ({
    type: APPEND_USER_ACTIVITY,
    data
});

export const updateMarketSettings = (params, callback, successCallback) => {
    return (dispatch, getState) => {
        console.log(params?.images, 'condition', params)

        let newImages = [];
        params?.images?.forEach((item, index, array) => {
            newImages.push(item ? item[0] : [])
        })
        const tempBanners = params?.bannerData;
        const mappedBanners = tempBanners?.map(item => (item?.fileUrl ? { ...item, imageIndex: -1 } : item));;
        const bannerParams = {
            bannerData: mappedBanners,
            images: newImages
        };


        let testimonialImages = [];
        params?.images?.forEach((item, index, array) => {
            testimonialImages.push(item ? item[0] : [])
        })
        const tempTestimonials = params?.testimonialData;
        for (let i = 0; i < tempTestimonials?.length; i++) {
            delete tempTestimonials[i].image;
        }

        const mappedTestimonials = tempTestimonials?.map(item => item?.imageUrl ? { ...item, imageIndex: -1 } : item)
        console.log({ mappedTestimonials })
        const testimonialsParams = {
            testimonialData: mappedTestimonials,
            images: testimonialImages
        }

        let outStandingImages = [];
        params?.images?.forEach((item, index, array) => {
            item?.map(item => outStandingImages.push(item ? item : []))
            // outStandingImages.push(item ? item : [])
        });

        const tempOutstandings = params?.outStandingResultData;
        for (let i = 0; i < tempOutstandings?.length; i++) {
            for (let j = 0; j < tempOutstandings[i]?.students?.length; j++) {
                delete tempOutstandings[i].students[j].file
                delete tempOutstandings[i].students[j].image
            }
        }
        console.log({ tempOutstandings })
        console.log({ outStandingImages })

        const outStandingParams = {
            outStandingResultData: tempOutstandings,
            images: outStandingImages
        }

        const paramsToSend = params?.bannerData && params?.images ? bannerParams : params?.testimonialData && params?.images ? testimonialsParams : outStandingParams

        console.log({ paramsToSend })
        const url = `/market/general-setting/save`;
        if ((params?.bannerData && params?.images) || (params.testimonialData && params.images || params.outStandingResultData && params.images)) {
            return Api.post(url).uploadMultiple(paramsToSend, (percent, response) => {
                if (typeof response !== 'undefined' && response?.show?.type != 'error') {
                    console.log({ response })
                    if (successCallback) {
                        successCallback();
                    }
                }
                callback();
            });
        } else {
            return Api.post(url).params(params).send((response, error) => {
                if (response && response.show.type === "success") {
                    successCallback();
                }
                callback();
            });
        };
    }
}

export const getMarketPlaceSettings = () => {
    return (dispatch, getState) => {

        const url = `/market/general-setting/get-market-place`;
        return Api.get(url).send((response, error) => {
            if (response) {
                dispatch(storeMarketPlaceSetting(response));
            }
        });
    };
};

export const getDropDownCourseList = (params, callback) => {
    return (dispatch, getState) => {

        const url = `/course/autocomplete-resources?names=true&emptySearch=true&published=${params}`;
        return Api.get(url).send((response, error) => {
            if (response) {
                callback(response);
            }
        });
    };
};

/* new api integrate and start */
export const ADD_STAFF_SUCCESS = 'ADD_STAFF_SUCCESS';

export const addStaffSuccess = (data) => ({
    type: ADD_STAFF_SUCCESS,
    data
});

export const extractErrorMessage = (err, fallback = "Failed to add staff") => {
    if (!err) return fallback;
    if (typeof err === "string" && err.trim()) return err.trim();

    // Check if err is wrapped in an Axios error (err.response.data) or is already response data
    const payload = (err && typeof err === "object" && err.response && err.response.data)
        ? err.response.data
        : err;

    if (typeof payload === "string" && payload.trim()) return payload.trim();

    if (payload && typeof payload === "object") {
        // 1. Check payload.show.message (string or { title, description })
        const showMsg = payload?.show?.message;
        if (typeof showMsg === "string" && showMsg.trim()) return showMsg.trim();
        if (showMsg && typeof showMsg === "object") {
            if (typeof showMsg.description === "string" && showMsg.description.trim()) {
                return showMsg.description.trim();
            }
            if (typeof showMsg.title === "string" && showMsg.title.trim()) {
                return showMsg.title.trim();
            }
        }

        // 2. Check payload.message
        const msg = payload?.message;
        if (typeof msg === "string" && msg.trim()) return msg.trim();
        if (msg && typeof msg === "object") {
            if (typeof msg.description === "string" && msg.description.trim()) return msg.description.trim();
            if (typeof msg.message === "string" && msg.message.trim()) return msg.message.trim();
        }

        // 3. Check payload.error
        const errField = payload?.error;
        if (typeof errField === "string" && errField.trim()) return errField.trim();
        if (errField && typeof errField === "object") {
            if (typeof errField.message === "string" && errField.message.trim()) return errField.message.trim();
            if (typeof errField.description === "string" && errField.description.trim()) return errField.description.trim();
        }

        // 4. Check payload.msg
        const msgField = payload?.msg;
        if (typeof msgField === "string" && msgField.trim()) return msgField.trim();

        // 5. Check payload.err
        const errSimple = payload?.err;
        if (typeof errSimple === "string" && errSimple.trim()) return errSimple.trim();

        // 6. Check payload.errors (array or object)
        if (Array.isArray(payload?.errors) && payload.errors.length > 0) {
            const first = payload.errors[0];
            if (typeof first === "string" && first.trim()) return first.trim();
            if (first && typeof first === "object") {
                if (typeof first.message === "string" && first.message.trim()) return first.message.trim();
                if (typeof first.msg === "string" && first.msg.trim()) return first.msg.trim();
                if (typeof first.error === "string" && first.error.trim()) return first.error.trim();
            }
        } else if (payload?.errors && typeof payload.errors === "object") {
            const firstVal = Object.values(payload.errors)[0];
            if (typeof firstVal === "string" && firstVal.trim()) return firstVal.trim();
            if (Array.isArray(firstVal) && typeof firstVal[0] === "string" && firstVal[0].trim()) {
                return firstVal[0].trim();
            }
            if (firstVal && typeof firstVal === "object" && typeof firstVal.message === "string" && firstVal.message.trim()) {
                return firstVal.message.trim();
            }
        }

        // 7. Check payload.data (nested data e.g. payload.data.message)
        if (payload?.data && typeof payload.data === "object") {
            const nestedMsg = payload.data.message || payload.data.error || payload.data.msg;
            if (typeof nestedMsg === "string" && nestedMsg.trim()) return nestedMsg.trim();
        }
    }

    // 8. Check raw err.message (e.g. JS Error object)
    if (typeof err?.message === "string" && err.message.trim()) {
        return err.message.trim();
    }

    return fallback;
};

export const addStaff = (params, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff`;
        return Api.post(url, {}, { silent: true }).params(params).send((response, error) => {
            if (response && response.show && response.show.type === "success") {
                const staffData = {
                    ...(typeof response.data === "object" ? response.data : {}),
                    name: params.name,
                    role: params.roles?.[0] || "Operation",
                    roles: params.roles,
                    phone: params.phone,
                    email: params.email || "",
                    access: params.privilages?.[0] || "No access",
                    createdAt: response.data?.createdAt || new Date().toISOString(),
                };
                dispatch(addStaffSuccess({ ...response, data: staffData }));
            } else if (response && (response.show?.type === "error" || response.status === false || response.success === false || (response.error && !response.data))) {
                const errMsg = extractErrorMessage(response, "Failed to add staff");
                Notification.error("Error", errMsg);
            }
            if (error) {
                const errMsg = extractErrorMessage(error, "Failed to add staff");
                Notification.error("Error", errMsg);
            }
            if (callback) {
                callback(response, error);
            }
        }, true);
    };
};

export const GET_STAFF_STATS = 'GET_STAFF_STATS';

export const getStaffStatsSuccess = (data) => ({
    type: GET_STAFF_STATS,
    data
});

// params: { range: 'all' | 'last30' | 'custom', year, startDate, endDate, skipRedux }
// range defaults to 'all' server-side when omitted; year defaults to the
// current year when range is 'all' and year is omitted; startDate/endDate
// are required when range is 'custom'.
export const getStaffStats = (params, callback) => {
    return (dispatch, getState) => {
        const { skipRedux, ...queryParams } = params || {};
        const url = `/userv2/staff/stats`;
        return Api.get(url).params(queryParams).send((response, error) => {
            if (!skipRedux) {
                if (response && response.data) {
                    dispatch(getStaffStatsSuccess(response.data));
                } else if (response) {
                    dispatch(getStaffStatsSuccess(response));
                }
            }
            if (callback) {
                callback(response, error);
            }
        }, true);
    };
};
export const GET_STAFF_LIST_V3_SUCCESS = 'GET_STAFF_LIST_V3_SUCCESS';

export const getStaffListV3Success = (data) => ({
    type: GET_STAFF_LIST_V3_SUCCESS,
    data
});

export const getStaffListV3 = (params, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff`;
        // skipRedux: return the result only (search / filter fetches), so the
        // stored list stays the default one.
        const { skipRedux, ...queryParams } = params || {};
        return Api.get(url).params(queryParams).send((response, error) => {
            if (skipRedux) {
                // not stored
            } else if (response && response.data !== undefined) {
                // Normalize new API response to match the legacy format for UserTableV2
                dispatch(getStaffListV3Success({
                    items: response.data,
                    meta: { totalItems: response.total }
                }));
            } else if (response) {
                dispatch(getStaffListV3Success(response));
            }
            if (callback) {
                callback(response, error);
            }
        }, true);
    };
};

export const SEARCH_STAFF_V3_SUCCESS = 'SEARCH_STAFF_V3_SUCCESS';

export const searchStaffV3Success = (data) => ({
    type: SEARCH_STAFF_V3_SUCCESS,
    data
});

export const searchStaffV3 = (params, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/autocomplete`;
        return Api.get(url).params(params).send((response, error) => {
            if (response && response.data !== undefined) {
                dispatch(searchStaffV3Success({
                    items: response.data,
                    meta: { totalItems: response.data.length }
                }));
            } else if (response) {
                dispatch(searchStaffV3Success(response));
            }
            if (callback) {
                callback(response, error);
            }
        });
    };
};

export const updateStaffStatusV3 = (userId, status, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}/status`;
        return Api.patch(url).params({ status }).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        });
    };
};

export const GET_STAFF_PENDING_SUCCESS = 'GET_STAFF_PENDING_SUCCESS';

export const getStaffPendingSuccess = (data) => ({
    type: GET_STAFF_PENDING_SUCCESS,
    data
});

// GET /userv2/staff/pending — pending staff registration requests.
export const getStaffPending = (params, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/pending`;
        return Api.get(url).params(params).send((response, error) => {
            if (response) {
                dispatch(getStaffPendingSuccess(response));
            }
            if (callback) {
                callback(response, error);
            }
        });
    };
};

// PATCH /userv2/staff/pending/:reqId/approve  { roles, permissions }
export const approveStaffRegistration = (reqId, params, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/pending/${reqId}/approve`;
        return Api.patch(url).params(params).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        });
    };
};

// PATCH /userv2/staff/pending/:reqId/reject  { reason }
export const rejectStaffRegistration = (reqId, params, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/pending/${reqId}/reject`;
        return Api.patch(url).params(params).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        });
    };
};

// GET /userv2/staff/:userId — full staff profile (for "View profile").
export const getStaffProfile = (userId, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}`;
        // timed=true: sent immediately instead of Api.send's default 1s
        // debounce (profile reload after Save in Basic details).
        return Api.get(url).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        }, true);
    };
};

// PATCH /userv2/staff/:userId — roles/privilages REPLACE the full set (for "Edit details").
export const updateStaffProfile = (userId, params, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}`;
        // timed=true: sent immediately (no 1s Api.send debounce).
        return Api.patch(url).params(params).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        }, true);
    };
};

// POST /staff/:userId/photo — multipart upload/replace staff profile photo
// (field name: file). Uses uploadAndPost (not the .send() queue) since this
// is multipart, not JSON — callback receives (percent, response) the same
// way saveProfileDetails' image upload used to.
export const uploadStaffPhoto = (userId, file, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}/photo`;
        return Api.uploadAndPost(url, { file }, callback);
    };
};

// POST /userv2/staff/:userId/documents — multipart upload a new document to
// this staff member's profile (field name: file; pdf/doc/docx/jpg/jpeg/png,
// max 10MB). Response is the newly created Document row. Same uploadAndPost
// shape as uploadStaffPhoto above — callback fires repeatedly with just a
// percent during upload, then finally with (100, response) on success or
// (-1) on failure (response is the raw axios response, so the created
// Document row is response.data).
export const uploadStaffDocument = (userId, file, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}/documents`;
        return Api.uploadAndPost(url, { file }, callback);
    };
};

// GET /userv2/staff/:userId/documents — every document uploaded for this
// staff member, newest first. No reducer wiring, same as getStaffProfile
// above — the caller (StaffProfilePage) keeps its own local state.
export const getStaffDocuments = (userId, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}/documents`;
        return Api.get(url).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        });
    };
};

// PATCH /userv2/staff/:userId/documents/:documentId — replace the file
// behind an existing document row (id stays the same; fileName/fileType/
// fileSize/s3Path/uploadedAt update to the new file). Multipart, so this
// chains .patch(url) (which only sets the URL/method) into uploadAndPatch
// (which reads that URL) rather than .send() — same percent/(100,response)/
// (-1) callback shape as uploadStaffPhoto/uploadStaffDocument.
export const replaceStaffDocument = (userId, documentId, file, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}/documents/${documentId}`;
        return Api.patch(url).uploadAndPatch({ file }, callback);
    };
};

// DELETE /userv2/staff/:userId/documents/:documentId — permanently deletes
// the document (file + row), cannot be undone. Response body is empty on
// success, so callers should only branch on `error`, not on response being
// truthy.
export const deleteStaffDocument = (userId, documentId, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}/documents/${documentId}`;
        return Api.delete(url).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        });
    };
};

// DELETE /userv2/staff/:userId/photo — remove staff profile photo.
export const deleteStaffPhoto = (userId, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}/photo`;
        return Api.delete(url).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        });
    };
};

// PATCH /userv2/staff/status — bulk status update, e.g. bulk delete/suspend
// via { userIds, status }. Response is partial-success shaped:
// { succeeded: number[], failed: [{ userId, reason }] } — a super admin in
// the selection, for example, fails while the rest still go through.
export const bulkUpdateStaffStatus = (userIds, status, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/status`;
        return Api.patch(url).params({ userIds, status }).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        });
    };
};

// GET /attendance/operation-attendance-tab/:operatorId?date=&year=
export const getOperationAttendanceTab = (operatorId, params, callback) => {
    return (dispatch, getState) => {
        const query = { ...(params || {}) };
        if (!query.date) delete query.date;
        if (!query.year) delete query.year;
        const url = `/attendance/operation-attendance-tab/${operatorId}`;
        return Api.get(url).params(query).send((response, error) => {
            if (callback) {
                callback(response, error);
            }
        });
    };
};

// GET /staff/:userId/activity-stats
export const getStaffActivityStats = (userId, callback) => {
    return (dispatch, getState) => {
        const url = `/userv2/staff/${userId}/activity-stats`;
        return Api.get(url).send((response, error) => {
            if (error && error.status === 404) {
                return Api.get(`/staff/${userId}/activity-stats`).send((res2, err2) => {
                    if (callback) callback(res2, err2);
                });
            }
            if (callback) {
                callback(response, error);
            }
        });
    };
};

/* new api integrate and end */